module.exports = __webpack_public_path__ + "static/bs-351d98daffdb7faa9a1d1e5b170aea3f.png";